import {
  Component,
  Input,
  ViewEncapsulation,
  EventEmitter,
  Output,
  OnInit,
  HostListener,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { TrackingPageModel } from '../../tracking-page.model';
import { isEqual } from 'lodash';
import { StorageService } from '../../../storage';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-tracking-page-header',
  templateUrl: './tracking-page-header.component.html',
  styleUrls: ['./tracking-page-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TrackingPageHeaderComponent implements OnInit, OnChanges {
  @Input() noSidebar: boolean;
  @Input() noSidebarButton: boolean;
  @Input() mode: any;
  @Input() logo: string;
  @Input() trackingPage: TrackingPageModel;
  @Input() preventNavigation: boolean;
  @Input() searchPage: boolean;
  @Input() selectedId: any;
  @Input() isVisualBuilder = true;
  @Output() toggleSidebar = new EventEmitter();
  @Output() onSearchClick = new EventEmitter();
  @Output() selectBlock = new EventEmitter();
  @Output() changeLanguage = new EventEmitter();
  isMobile: boolean;

  constructor(
    private storageService: StorageService,
    private translate: TranslateService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  get searchButtonStyles() {
    const { borderWidth, borderRadius, borderColor, backgroundColor, shadow } =
      this.trackingPage.searchButton;
    return {
      'borderWidth.px': borderWidth,
      'borderRadius.px': borderRadius,
      borderColor,
      backgroundColor,
      'box-shadow': shadow
    };
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.isMobile =
      this.mode === 'mobile' || window.matchMedia('(max-width: 767px)').matches;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.mode) {
      this.onResize();
    }
  }

  ngOnInit() {
    this.onResize();
  }

  onHeaderClick({ target }, header, nav, container) {
    if (
      isEqual(target, nav) ||
      isEqual(target, header) ||
      isEqual(target, container)
    ) {
      this.selectBlock.emit('header');
    }
  }

  onAnchorClick(event) {
    if (this.isVisualBuilder) {
      event.preventDefault();
    }
  }

  backToSearch() {
    this.router.navigate(['tp', 'search'], {
      queryParams: this.route.snapshot.queryParams
    });
  }
  get marginStyles() {
    const { top, right, bottom, left } = this.trackingPage.socialIcons.margin;
    return {
      'marginTop.px': top || 0,
      'marginRight.px': right || 0,
      'marginBottom.px': bottom || 0,
      'marginLeft.px': left || 0
    };
  }
}
